module.exports = __webpack_public_path__ + "static/media/i37.198fd4b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i37.svg
// module id = 355
// module chunks = 12